export const codeErrorResponse = (codeErr, section) => {

    let codeE = String(codeErr)

    let catalogo = {
        "ERR000" : "Error no especificado contactar sistemas",
        "ERR001" : "Número de tarjeta inválida, verifique…",
        "ERR002" : "Nombre inválido, verifique…",
        "ERR003" : "Tarjeta con código de rechazo",
        "ERR004" : "Cuenta con atraso",
        "ERR005" : "Tarjeta con límite de crédito en cero",
        "ERR006" : "Error técnico",
        "ERR007" : "¡Lo sentimos!, no puedes registrar esta tarjeta ya se encuentra asociada a otra cuenta SEARS.",
        "ERR008" : "no se tiene el error registrado en los datos de sears",
        "ERR009" : "no se tiene el error registrado en los datos de sears",
        "ERR010" : "Número de tarjeta o usuario incorrecto",
        "ERR011" : "Error no especificado contactar sistemas",
        "ERR029" : "no se tiene el error registrado en los datos de sears",
        "ER00000000" : "Error no especificado contactar sistemas",
        "ER00000001" : "Falta nombre",
        "ER00000002" : "Nombre con caracteres invalidos",
        "ER00000003" : "Falta apellido paterno",
        "ER00000004" : "Apellido Paterno con caracteres invalidos",
        "ER00000005" : "Apellido materno con caracteres invalidos",
        "ER00000006" : "fecha nacimiento mayor a 8 caracteres",
        "ER00000007" : "Edad mas de dos caracteres",
        "ER00000008" : "Edad no numerico",
        "ER00000009" : "falta direccion",
        "ER00000010" : "falta colonia",
        "ER00000011" : "falta ciudad",
        "ER00000012" : "falta estado",
        "ER00000013" : "estado mayor a dos caracteres",
        "ER00000014" : "falta cp",
        "ER00000015" : "cp mayor a cinco caracteres",
        "ER00000016" : "cp no es numerico",
        "ER00000017" : "falta telefono",
        "ER00000018" : "telefono mayor a 10 caracteres",
        "ER00000019" : "telefono no es numerico",
        "ER00000020" : "Falta TiempoResAnio",
        "ER00000021" : "Tiempo residencia año mayor a 2 caracteres",
        "ER00000022" : "Tiempo residencia año no es numerico",
        "ER00000023" : "Falta TiempoResMes",
        "ER00000024" : "Tiempo residencia meses nacimiento mayor a 2 caracteres",
        "ER00000025" : "Tiempo residencia meses no es númerico",
        "ER00000026" : "Tiempo residencia meses mayor a 11",
        "ER00000027" : "Monto renta requerido cuando el tipo de vivienda es R",
        "ER00000028" : "Monto renta mayor 10 caracters",
        "ER00000029" : "Monto renta caracteres invalidos",
        "ER00000030" : "TipoVivienda requerido",
        "ER00000031" : "TipoVivienda mayor a dos caracteres",
        "ER00000032" : "Tiempo vivienda caracteres invalidos",
        "ER00000033" : "No. dependientes mayor a dos caracters",
        "ER00000034" : "No. dependientes caracteres invalidos",
        "ER00000035" : "TipoEmpresa mayor a dos caracters",
        "ER00000036" : "TipoEmpresa caracteres invalidos",
        "ER00000037" : "Falta Tiempo en empresa en años",
        "ER00000038" : "Tiempo en empresa año mayor a 2 caracteres",
        "ER00000039" : "Tiempo en empresa año caracteres invalidos",
        "ER00000040" : "Falta Tiempo en empresa meses",
        "ER00000041" : "Tiempo en empesa en meses mayor a 2 caracteres",
        "ER00000042" : "Tiempo en empresa meses no es numerico",
        "ER00000043" : "Tiempo en empresa meses mayor a 11",
        "ER00000044" : "Falta ocupación",
        "ER00000045" : "Ocupación mayor a 2 caracteres",
        "ER00000046" : "Ocupación caracteres invalidos",
        "ER00000047" : "Falta Ingreso mensual",
        "ER00000048" : "Ingreso mensual mayor a 2 caracteres",
        "ER00000049" : "Ingreso mensual caracteres invalidos",
        "ER00000050" : "Falta DireccionEmpleo",
        "ER00000051" : "Falta Ciudad empleo",
        "ER00000052" : "Falta Estado Empleo",
        "ER00000053" : "Estado Empleo mayor a 2 caracteres",
        "ER00000054" : "Falta CP Empleo",
        "ER00000055" : "CP Empleo mayor a 5 caracteres",
        "ER00000056" : "CP Empleo debe ser numerico",
        "ER00000057" : "Falta Telefono Empleo",
        "ER00000058" : "telefono empleo debe ser 10 caracteres",
        "ER00000059" : "telefono empleo es numerico",
        "ER00000060" : "extension diferente de 4 digitos",
        "ER00000061" : "OtroIngresos mayor a 10 posiciones",
        "ER00000062" : "OtroIngresos es númerico",
        "ER00000063" : "Falta RFC",
        "ER00000064" : "RFC mal escrito",
        "ER00000065" : "Tarjeta Credito es mayor 20 caractes",
        "ER00000066" : "Tarjeta Credito es númerico",
        "ER00000067" : "Email sin estructura",
        "ER00000068" : "No hay colonia de la referencia 1",
        "ER00000069" : "No hay Telefono 1",
        "ER00000070" : "Telefono 1 tiene que ser 10 posiciones",
        "ER00000071" : "Telefono Referencia1 no es númerico",
        "ER00000072" : "No hay parentesco 1",
        "ER00000073" : "Parentesco 1 tiene que ser 1 posicion",
        "ER00000074" : "Parentesco 1 caracteres invalidos",
        "ER00000075" : "No hay colonia de la referencia 2",
        "ER00000076" : "No hay Telefono 2",
        "ER00000077" : "Telefono 2 tiene que ser 10 posiciones",
        "ER00000078" : "Telefono Referencia2 no es númerico",
        "ER00000079" : "No hay parentesco 2",
        "ER00000080" : "Parentesco 2 tiene que ser 1 posicion",
        "ER00000081" : "Parentesco 2 caracteres invalidos",
        "ER00000082" : "Telefono 3 tiene que ser 10 posiciones",
        "ER00000083" : "Telefono Referencia3 no es númerico",
        "ER00000084" : "Parentesco 3 tiene que ser 1 posicion",
        "ER00000085" : "Parentesco 3 caracteres invalidos",
        "ER00000086" : "Falta Genero",
        "ER00000087" : "Genero mayor a 1 carácter",
        "ER00000088" : "Genero caracteres invalidos",
        "ER00000089" : "Falta Starjeta",
        "ER00000090" : "STarjeta mayor a 2 caracteres",
        "ER00000091" : "STarjeta caracteres invalidos",
        "ER00000092" : "Digitos tienen que ser 4",
        "ER00000093" : "Digitos tienen que ser numerico",
        "ER00000094" : "Falta Shipotecario",
        "ER00000095" : "SHipotecario mayor a 2 caracteres",
        "ER00000096" : "SHipotecario caracteres invalidos",
        "ER00000097" : "Falta Sautomotriz",
        "ER00000098" : "SAutomotriz mayor a 2 caracteres",
        "ER00000099" : "SAutomotriz caracteres invalidos",
        "ER00000100" : "Falta Autorizacion",
        "ER00000101" : "Autorizacion mayor a 2 caracteres",
        "ER00000102" : "Autorizacion caracteres invalidos",
        "ER00000103" : "Celudar debe ser obligatorio",
        "ER00000104" : "Celular debe ser 10 posiciones",
        "ER00000105" : "Celular debe ser numerico",
        "FL00000000" : "Fuera de linea",
        "UnsupportedApiVersion" : "The HTTP resource that matches the request URI 'http://10.128.14.47:6062/credito-sears/v1/cards/movements' does not support HTTP method 'GET'.",
        "ER0PAY0" : "¡Lo sentimos! No podemos continuar, la cantidad mínima para realizar un pago es de $1.00",
    }

    if(section === "formShort"){
        catalogo = {
            "ERR001": "Falta nombre",
            "ERR002": "Nombre con caracteres invalidos",
            "ERR003": "Falta apellido paterno",
            "ERR004": "Apellido Paterno con caracteres invalidos",
            "ERR005": "Apellido materno con caracteres invalidos",
            "ERR006": "Fecha nacimiento mayor a 8 caracteres",
            "ERR009": "Falta direccion",
            "ERR010": "Falta colonia",
            "ERR011": "Falta ciudad",
            "ERR012": "Falta estado",
            "ERR013": "Estado mayor a dos caracteres",
            "ERR014": "Falta cp",
            "ERR015": "Cp mayor a cinco caracteres",
            "ERR016": "Cp no es numerico",
            "ERR017": "Falta telefono",
            "ERR018": "Teléfono mayor a 10 caracteres",
            "ERR019": "Teléfono no es numerico",
            "ERR020": "Falta TiempoResAnio",
            "ERR021": "Tiempo residencia año mayor a 2 caracteres",
            "ERR022": "Tiempo residencia año no es numerico",
            "ERR023": "Falta TiempoResMes",
            "ERR024": "Tiempo residencia meses nacimiento mayor a 2 caracteres",
            "ERR025": "Tiempo residencia meses no es númerico",
            "ERR026": "Tiempo residencia meses mayor a 11",
            "ERR027": "Monto renta requerido cuando el tipo de vivienda es R",
            "ERR028": "Monto renta mayor 10 caracters",
            "ERR029": "Monto renta caracteres invalidos",
            "ERR030": "TipoVivienda requerido",
            "ERR031": "TipoVivienda mayor a dos caracteres",
            "ERR032": "Tiempo vivienda caracteres invalidos",
            "ERR033": "No. dependientes mayor a dos caracters",
            "ERR034": "No. dependientes caracteres invalidos",
            "ERR035": "TipoEmpresa mayor a dos caracters",
            "ERR036": "TipoEmpresa caracteres invalidos",
            "ERR037": "Falta Tiempo en empresa en años",
            "ERR038": "Tiempo en empresa año mayor a 2 caracteres",
            "ERR039": "Tiempo en empresa año caracteres invalidos",
            "ERR040": "Falta Tiempo en empresa meses",
            "ERR041": "Tiempo en empesa en meses mayor a 2 caracteres",
            "ERR042": "Tiempo en empresa meses no es numerico",
            "ERR043": "Tiempo en empresa meses mayor a 11",
            "ERR044": "Falta ocupación",
            "ERR045": "Ocupación mayor a 2 caracteres",
            "ERR046": "Ocupación caracteres invalidos",
            "ERR047": "Falta Ingreso mensual",
            "ERR048": "Ingreso mensual mayor a 2 caracteres",
            "ERR049": "Ingreso mensual caracteres invalidos",
            "ERR050": "Falta DireccionEmpleo",
            "ERR054": "Falta CP Empleo",
            "ERR055": "CP Empleo mayor a 5 caracteres",
            "ERR056": "CP Empleo debe ser numerico",
            "ERR057": "Falta Telefono Empleo",
            "ERR058": "telefono empleo debe ser 10 caracteres",
            "ERR059": "telefono empleo es numerico",
            "ERR060": "extension diferente de 4 digitos",
            "ERR061": "OtroIngresos mayor a 10 posiciones",
            "ERR062": "OtroIngresos es númerico",
            "ERR063": "Falta RFC",
            "ERR064": "RFC mal escrito",
            "ERR067": "Email sin estructura",
            "ERR086": "Falta Genero",
            "ERR087": "Genero mayor a 1 carácter",
            "ERR088": "Genero caracteres invalidos",
            "ERR089": "Falta Starjeta",
            "ERR090": "STarjeta mayor a 2 caracteres",
            "ERR091": "STarjeta caracteres invalidos",
            "ERR092": "Digitos tienen que ser 4",
            "ERR093": "Digitos tienen que ser numerico",
            "ERR094": "Falta Shipotecario",
            "ERR095": "SHipotecario mayor a 2 caracteres",
            "ERR096": "SHipotecario caracteres invalidos",
            "ERR097": "Falta Sautomotriz",
            "ERR098": "SAutomotriz mayor a 2 caracteres",
            "ERR099": "SAutomotriz caracteres invalidos",
            "ERR100": "Falta Autorizacion",
            "ERR101": "Autorizacion mayor a 2 caracteres",
            "ERR102": "Autorizacion caracteres invalidos",
            "ERR103": "Celudar debe ser obligatorio",
            "ERR104": "Celular debe ser 10 posiciones",
            "ERR105": "Celular debe ser numerico",
            "ERR107": "Información incompleta",
            "FL000": "Fuera de linea",
            "ERR000": "Error no especificado contactar sistemas"
        }
    }

    if(section === "addCardSears"){
        catalogo = {
            "ERR000" : "Error no especificado contactar sistemas",
            "ERR001" : "Número de tarjeta inválida, verifique…",
            "ERR002" : "Nombre inválido, verifique…",
            "ERR003" : "Tarjeta con código de rechazo",
            "ERR004" : "Cuenta con atraso",
            "ERR005" : "Tarjeta con límite de crédito en cero",
            "ERR006" : "Error técnico",
            "ERR007" : "¡Lo sentimos!, no puedes registrar esta tarjeta ya se encuentra asociada a otra cuenta SEARS.",
            "ERR008" : "no se tiene el error registrado en los datos de sears",
            "ERR009" : "no se tiene el error registrado en los datos de sears",
            "ERR010" : "Número de tarjeta o usuario incorrecto",
            "ERR011" : "Por favor, valida que los datos que ingresaste sean correctos.",
            "ERR012" : "Número de teléfono incorrecto",
            "ERR013" : "Falta número de teléfono"
        }
    }

    if(section === "choiseCards" || section === "addCard"){
        catalogo = {
            "30" : " Por favor valida que los datos sean correctos o elige otra forma de pago.",
            "31" : "Tu banco rechazo la compra, favor de comunciarte con ellos o elige otra forma de pago.",
            "32" : "Tu banco rechazo la compra, favor de comunciarte con ellos o elige otra forma de pago.",
            "33" : "Hemos cerrado tu sesión por motivos de seguridad.",
            "34" : " Tu tarjeta no esta habilitada para compras por Internet, por favor, comunicate con tu banco o elige otra forma de pago.",
            "35" : "Tu compra no fue autoizada, por favor elige otra forma de pago"
        }
    }

    if(section === "paperLess"){
        catalogo = {
            "01": "Cuenta no existe",
            "02": "Error de formato",
            "03": "Error de base de datos",
            "04": "Error Genérico",
            "05": "Tipo de cuenta inválida",
            "06": "Correo electrónico invalido",
            "07": "Opción marcada inválida",
            "08": "Autorización no seleccionada",
            "09": "ID Aplicativo no existe"
        }
    }
    
    let messageError = catalogo[codeE]

    return messageError
}